import styled, { css } from "styled-components";

export interface GridRowTwoBoxProps {
	posterHeight: number;
	gridCol: number;
	cardWidth: number | string;
	gridGap: number;
	gridWidth: number;
}
export const GridRowTwoBaseBox = styled.section`
	display: grid;
	flex-wrap: wrap;
	grid-row-gap: 8px;
	margin: 0 auto;

	${(props: GridRowTwoBoxProps) => {
		const gap = props.gridGap || 12;
		if (typeof props.cardWidth === "number") {
			return css`
				width: ${props.gridWidth}px;
				grid-column-gap: ${gap}px;
				grid-template-columns: repeat(auto-fill, ${props.cardWidth}px);
			`;
		}
		return css`
			grid-column-gap: ${gap}px;
			width: ${props.cardWidth};
		`;
	}}

	@supports not (display: grid) {
		display: flex;
		grid-gap: 0;

		& > * {
			${(props: GridRowTwoBoxProps) => {
				const gap = props.gridGap || 12;
				return css`
					margin-right: ${gap}px;
					margin-bottom: 8px;
				`;
			}}
		}
	}
`;
export const GridRowLessTwoBox = styled(GridRowTwoBaseBox)`
	grid-auto-flow: row dense;

	@supports not (display: grid) {
		& > * {
			${(props: GridRowTwoBoxProps) => {
				return css`
					&:nth-child(${props.gridCol}n) {
						margin-right: 0;
					}
				`;
			}}
		}
	}
`;

export const GridRowTwoBox = styled(GridRowTwoBaseBox)`
	grid-auto-flow: column dense;
	grid-template-rows: 1fr 1fr;

	@supports not (display: grid) {
		flex-direction: column;

		& > * {
			${(props: GridRowTwoBoxProps) => {
				return css`
					&:nth-child(${props.gridCol * 2}n),
					&:nth-child(${props.gridCol * 2}n - 1) {
						margin-right: 0;
					}
				`;
			}}
		}
	}
`;
export const GridRowTwoScroll = styled.section`
	display: normal;
`;


export const DoubleContainer = styled.section`
	position: relative;
	overflow: hidden;

	.scrollContainer {
		overflow: hidden;

		.box {
			text-align: left;
			width: 1200px;
			overflow: hidden;
			display: inline-block;
			vertical-align: middle;
		}
	}
`;
